export default {
  "content": "<path d=\"M11.29 19.71l1.41-1.41L7.41 13H19v-2H7.41l5.29-5.29-1.41-1.41-7 7a.996.996 0 000 1.41l7 7z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};